/* eslint-disable prettier/prettier */ 'use client';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation, staticHotelInformationIB, getMultiSearchParamsIB } from '@whitbread-eos/utils/server';
import Image from 'next/image';
import { useSearchParams, useParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';
const EditSearch = ({ searchIcon, handleEditClick = ()=>{
    return;
}, language })=>{
    var _t, _t_searchData_arrival_getMonth, _t1;
    const { t } = useTranslation();
    const { slug } = useParams();
    const searchParams = useSearchParams();
    const searchParamsObj = {};
    searchParams.forEach((value, key)=>{
        searchParamsObj[key] = value;
    });
    const roomTypeTranslations = {
        DB: t('content.global.double'),
        DIS: t('content.global.accessible'),
        FAM: t('content.global.family'),
        SB: t('content.global.single'),
        TWIN: t('content.global.twin')
    };
    const hotelFullSlug = slug ? `/hotels/${Array.isArray(slug) ? slug.join('/') : slug}` : undefined;
    const [searchData, setSearchData] = useState({
        location: '',
        adults: 0,
        children: 0,
        nights: 0,
        arrival: new Date(),
        roomTypeCount: {}
    });
    var _searchParamsObj_searchModelsearchTerm;
    const locationFromUrl = (_searchParamsObj_searchModelsearchTerm = searchParamsObj['searchModel.searchTerm']) !== null && _searchParamsObj_searchModelsearchTerm !== void 0 ? _searchParamsObj_searchModelsearchTerm : '';
    const parseRooms = (rooms)=>{
        let totalAdults = 0;
        let totalChildren = 0;
        const roomsCount = {};
        rooms === null || rooms === void 0 ? void 0 : rooms.map((room)=>{
            totalAdults += room.adults;
            totalChildren += room.children;
            if (roomsCount[room.roomType]) {
                roomsCount[room.roomType] += 1;
            } else {
                roomsCount[room.roomType] = 1;
            }
        });
        setSearchData((prevState)=>_object_spread_props(_object_spread({}, prevState), {
                adults: totalAdults,
                children: totalChildren,
                roomTypeCount: roomsCount
            }));
    };
    useEffect(()=>{
        const getData = function() {
            var _ref = _async_to_generator(function*() {
                if (hotelFullSlug) {
                    const hotelInformationSlug = yield staticHotelInformationIB(hotelFullSlug, language);
                    setSearchData((prevState)=>{
                        var _hotelInformationSlug_name;
                        return _object_spread_props(_object_spread({}, prevState), {
                            location: (_hotelInformationSlug_name = hotelInformationSlug === null || hotelInformationSlug === void 0 ? void 0 : hotelInformationSlug.name) !== null && _hotelInformationSlug_name !== void 0 ? _hotelInformationSlug_name : ''
                        });
                    });
                }
            });
            return function getData() {
                return _ref.apply(this, arguments);
            };
        }();
        getData();
    }, [
        hotelFullSlug,
        locationFromUrl,
        language
    ]);
    useEffect(()=>{
        if (hotelFullSlug || locationFromUrl) {
            const { arrival: arrivalFromUrl, numberOfNights, rooms: roomsFromUrl } = getMultiSearchParamsIB(searchParamsObj);
            setSearchData((prevState)=>_object_spread_props(_object_spread({}, prevState), {
                    location: locationFromUrl,
                    nights: numberOfNights,
                    arrival: new Date(arrivalFromUrl)
                }));
            parseRooms(roomsFromUrl);
        }
    }, [
        hotelFullSlug,
        locationFromUrl
    ]);
    const dateText = `${(_t = t('content.form.datePicker.weekdaysShort')) === null || _t === void 0 ? void 0 : _t[searchData.arrival.getDay() - 1]} ${searchData.arrival.getDate()} ${(_t1 = t('content.form.datePicker.months')) === null || _t1 === void 0 ? void 0 : (_t_searchData_arrival_getMonth = _t1[searchData.arrival.getMonth()]) === null || _t_searchData_arrival_getMonth === void 0 ? void 0 : _t_searchData_arrival_getMonth.slice(0, 3)} ${searchData.arrival.getFullYear()}`;
    const adultsText = `, ${searchData.adults} ${searchData.adults === 1 ? t('content.global.adult') : t('content.global.adults')}`;
    const childrenText = `, ${searchData.children} ${searchData.children === 1 ? t('content.global.child') : t('content.global.children')}`;
    const nightsText = `, ${searchData.nights} ${searchData.nights === 1 ? t('content.global.night') : t('content.global.nights')}`;
    const roomTypeText = Object.entries(searchData.roomTypeCount).map(([type, count])=>`, ${count} ${roomTypeTranslations[type]} ${count === 1 ? t('content.global.room') : t('content.global.rooms')}`);
    return /*#__PURE__*/ _jsxs("div", {
        className: editSearchContainerStyle,
        "data-testid": "Edit-Search-IB",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: editSearchTopStyle,
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        src: searchIcon,
                        alt: 'Search Details Icon',
                        width: 24,
                        height: 24
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: editSearchLocationStyle,
                        "data-testid": "Edit-Search-Location",
                        children: searchData.location
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: editSearchButtonStyle,
                        "data-testid": "Edit-Search-Button",
                        onClick: handleEditClick,
                        children: t('content.form.searchEdit')
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: editSearchBottomStyle,
                "data-testid": "Edit-Search-Details",
                children: [
                    dateText,
                    adultsText,
                    searchData.children ? childrenText : '',
                    nightsText,
                    roomTypeText
                ]
            })
        ]
    });
};
export default EditSearch;
const editSearchContainerStyle = 'hidden mobile:flex flex-col p-4 gap-2';
const editSearchTopStyle = 'flex gap-4';
const editSearchLocationStyle = 'font-semibold truncate';
const editSearchButtonStyle = 'ml-[auto] underline text-secondaryColor';
const editSearchBottomStyle = 'border-b border-lightGrey3 pb-4';
